/* eslint-disable import/no-duplicates */
import { Locale } from "date-fns";
import { ru, enUS } from "date-fns/locale";
import buildLocalizeFn from "date-fns/locale/_lib/buildLocalizeFn";
import i18n from "i18next";

type FormatRelativeLocaleType = {
  lastWeek: string;
  yesterday: string;
  today: string;
  tomorrow: string;
  nextWeek: string;
  other: string;
};

const formatRelativeLocaleEn = {
  lastWeek: "dd.MM.yyyy",
  yesterday: "dd.MM.yyyy",
  today: "'Today'",
  tomorrow: "'Tomorrow'",
  nextWeek: "dd.MM.yyyy",
  other: "dd.MM.yyyy",
};

type IToken = keyof FormatRelativeLocaleType;

const localeEn: Locale = {
  ...enUS,
  formatRelative: (token: IToken) => formatRelativeLocaleEn[token],
};

const formatRelativeLocaleRu = {
  lastWeek: "dd.MM.yyyy",
  yesterday: "dd.MM.yyyy",
  today: "'Сегодня'",
  tomorrow: "'Завтра'",
  nextWeek: "dd.MM.yyyy",
  other: "dd.MM.yyyy",
};

const localeRu: Locale = {
  ...ru,
  formatRelative: (token: IToken) => formatRelativeLocaleRu[token],
};

const monthValues = {
  narrow: ["Г", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"] as const,
  abbreviated: [
    "гыйн.",
    "фев.",
    "март",
    "апр.",
    "май",
    "июнь",
    "июль",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек.",
  ] as const,
  wide: [
    "гыйнвар",
    "февраль",
    "март",
    "апрель",
    "май",
    "июнь",
    "июль",
    "август",
    "сентябрь",
    "октябрь",
    "ноябрь",
    "декабрь",
  ] as const,
};

const formattingMonthValues = {
  narrow: ["Г", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"] as const,
  abbreviated: [
    "гыйн.",
    "фев.",
    "март",
    "апр.",
    "мая",
    "июн.",
    "июл.",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек.",
  ] as const,
  wide: [
    "гыйнварның",
    "февральнең",
    "мартның",
    "апрельнең",
    "майның",
    "июньнең",
    "июльнең",
    "августның",
    "сентябрьнең",
    "октябрьнең",
    "ноябрьнең",
    "декабрьнең",
  ] as const,
};

const dayValues = {
  narrow: ["Я", "Д", "С", "Ч", "П", "Җ", "Ш"] as const,
  short: ["яш", "дш", "сш", "чш", "пн", "җм", "шм"] as const,
  abbreviated: ["якш", "дүш", "сиш", "чәр", "пән", "җом", "шим"] as const,
  wide: [
    "якшәмбе",
    "дүшәмбе",
    "сишәмбе",
    "чәршәмбе",
    "пәнҗешәмбе",
    "җомга",
    "шимбә",
  ] as const,
};

// Танцы с бубном потому что в интернете нет перевод дат на татарский язык
const localeTT: Locale = {
  ...ru,
  code: "tt",
  localize: {
    ...ru.localize,
    month: buildLocalizeFn({
      values: monthValues,
      defaultWidth: "wide",
      formattingValues: formattingMonthValues,
      defaultFormattingWidth: "wide",
    }),

    day: buildLocalizeFn({
      values: dayValues,
      defaultWidth: "wide",
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any,
};

export function getCurrentLocale(): Locale {
  if (i18n.language === "ru") return localeRu;
  if (i18n.language === "tt") return localeTT;
  return localeEn;
}
